// @flow

import type { StoreResourceDef } from 'app/core/types'

export const progressionStatus: StoreResourceDef<> = {
  resourceType: 'progressionStatus',
}
